export class PageControls {
    /**
     * Controller for manipulating with content & data in relation to page-controls-component
     * @param {HTMLElement} element 
     */
    constructor(element) {
        // Name, reference
        element.PageControls = this;
        
        // Refs
        this._refs = {
            el: element,
            footer: document.querySelector('#footer')
        };

        // Properties
        this._props = {
            intervalId: null,
            maxLimit: 10
        };

        // Boot component 
        const fn = this._oLark.bind(this); 
        this._props.intervalId = setInterval(fn, 50);

        // Footer placement
        if (this._refs.footer != null) {
            this._refs.footer.style.marginBottom = this._refs.el.getClientRects()[0].height + 'px'; 
        }
    }

    /**
     * _onLoad
     * Execute calculations for placing callcenter-form
     */
    _oLark () {
        const 
            oChat = document.querySelector('.olark-launch-button'),
            oGrabber = document.querySelector('.olark-attention-grabber');
           
        if(this._props.maxLimit <= 0)  clearInterval(this._props.intervalId);

        if(oChat != null) {
            const intChatPosition = this._refs.el.getClientRects()[0].height + 10;
            oChat.setAttribute('style', 'bottom: ' + intChatPosition + 'px !important'); 

            if(oGrabber != null) {
                const intGrabberPosition = this._refs.el.getClientRects()[0].height + 65;
                oGrabber.setAttribute('style', 'bottom: ' + intGrabberPosition + 'px !important');
            }

            clearInterval(this._props.intervalId);
        }
    }
}